<template>
    <v-dialog max-width="900px" v-model="sDialog" persistent>
        <v-card>
            <v-card-title>
                <div class="headline"
                     style="text-align: center;text-transform:uppercase;width: 100%;border-bottom: 1px solid gray">
                    <v-btn @click="sDialog=false" icon style="float: left"><v-icon>close</v-icon></v-btn>
                    Thêm học viên
                </div>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xm12 md12 sm12 lg12 xs12>
                            <div style="max-height: 400px;overflow-y: auto">
                                <v-form @keyup.enter.native="enterInList">
                                    <div v-if="step==0">
                                        <div class="header_info">Nhập thông tin học viên sẽ thêm vào Danh sách :
                                        </div>
                                        <v-data-table :headers="addStudentHeaders" :items="lstInsertStudent"
                                                      class="elevation-1" hide-actions key="insertTable">
                                            <template slot="items" slot-scope="props">
                                                <td class="text-xs-center">{{props.index+1}}</td>
                                                <td class="text-xs-left">
                                                    <input class="tableInput" :id="'fullName_'+props.index"
                                                           :row="props.index" :col="0"
                                                           v-model="props.item.fullName"/>
                                                    <div class="error--text">{{err.fullName[props.index]}}</div>
                                                </td>
                                                <td class="text-xs-left">
                                                    <input class="tableInput" v-model="props.item.email" @change="getStudentInfo(props.item,props.index)"
                                                           :id="'email_'+props.index" :row="props.index" :col="1"/>
                                                    <div class="error--text">{{err.email[props.index]}}</div>
                                                </td>
                                                <td class="text-xs-left">
                                                    <input class="tableInput" v-model="props.item.phone" @change="getStudentInfo(props.item,props.index)"
                                                           :id="'phone_'+props.index" :row="props.index" :col="2"/>
                                                    <div class="error--text">{{err.phone[props.index]}}</div>
                                                </td>
                                                <td class="justify-center">
                                                    <v-btn @click="removeInsertStudent(props.index)"
                                                           class="mx-0" icon>
                                                        <v-icon color="pink">delete</v-icon>
                                                    </v-btn>
                                                </td>
                                            </template>
                                        </v-data-table>
                                        <v-btn flat @click="pushEmptyStudent" class="primaryColor">
                                            <v-icon>add</v-icon>
                                            Thêm dòng
                                        </v-btn>
                                    </div>
                                    <div v-else-if="step==1">
                                        <div class="header_info">{{numberOfExistStudent()}} học viên bạn nhập thông tin đã được thêm vào Danh sách Học viên
                                        </div>
                                        <div class="header_info">Bạn sẽ Thêm {{numberOfAddStudent()}} học viên vào lớp {{cl.className}}</div>
                                        <v-data-table :headers="addStudentConfirmHeaders" :items="lstInsertStudent"

                                                      class="elevation-1" hide-actions key="verifyAccountcTable">
                                            <template slot="items" slot-scope="props">
                                                <td class="text-xs-center">{{props.index+1}}</td>
                                                <td class="text-xs-left">
                                                    {{props.item.fullName}}
                                                </td>
                                                <td class="text-xs-left">
                                                    {{props.item.email}}
                                                </td>
                                                <td class="text-xs-left">
                                                    {{props.item.phone}}
                                                </td>
                                                <td class="text-xs-left">
                                                    {{getAccountStatus(props.item)}}
                                                </td>
                                                <td class="justify-center">
                                                    {{getActionName(props.item)}}
                                                    <input class="tableInput" type="checkbox"
                                                           v-model="props.item.selected"
                                                           v-if="props.item.status == 0"/>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </div>
                                    <div v-else-if="step==2">
                                        <div class="header_info">Bạn đã thêm {{addSuccess}} Học viên vào lớp "{{cl.className}}".</div>
                                        <div class="header_info">{{numberOfCreateStudent()}} Học viên chưa có tài khoản Yoclass. Bạn sẽ tạo tài khoản Yoclass  cho Học viên?</div>
                                        <v-data-table :headers="studentCreateHeaders" :items="lstInsertStudent"
                                                      key="createAccountTable"

                                                      class="elevation-1" hide-actions>
                                            <template slot="items" slot-scope="props">
                                                <td class="text-xs-left">{{ props.index+1 }}</td>
                                                <td class="text-xs-left">{{ props.item.fullName }}</td>
                                                <td class="text-xs-left">{{ getUserName(props.item) }}</td>
                                                <td class="text-xs-left">
                                                    <input :key="'create_'+props.item.studentId" class="tableInput"
                                                           v-model="props.item.password"/>
                                                    <div class="error--text">{{err.password[props.index]}}</div>
                                                </td>
                                            </template>
                                        </v-data-table>
                                    </div>
                                    <div v-else-if="step==3" class="result_info">
                                        <div>Bạn đã tạo tài khoản Yoclass cho {{createdSuccess}} học viên <br/>
                                            Thông tin tài khoản và mật khẩu đăng nhập Yoclass.vn
                                            sẽ được gửi tới học viên theo email/số điện thoại vừa tạo.
                                        </div>
                                        <div> {{createdSuccess}} Học viên này sẽ được thêm vào lớp "{{cl.className}}"</div>
                                    </div>
                                    <div v-else class="result_info">
                                        THÊM HỌC VIÊN
                                        <div>Bạn đã hoàn thành thêm học viên cho lớp.
                                        </div>
                                    </div>
                                </v-form>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="onCheckAccount" class="yoprimary" v-if="step==0" dark>Tiếp tục</v-btn>
                <v-btn @click.native="onAddMember" class="yoprimary" v-else-if="step==1" dark>Thêm vào lớp</v-btn>
                <v-btn @click.native="onCreateAccount" class="yoprimary" v-else-if="step==2" dark>Tạo tài khoản</v-btn>
                <v-btn @click.native="sDialog=false" class="yoprimary" v-else dark>OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import Validator from "../../../public/js/validator";

    const v = Validator();

    export default {
        name: "add-student-component",

        props: {
            exerciseType: {
                type: String | Number,
                default: null
            },
            value: {
                type: Boolean,
                default: false
            },
            classId: {
                type: String | Number,
                default: null
            },
            cl: {
                type: Object,
                default: null
            },
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            step: 0,
            sortField: "fullName",
            orderBy: "asc",
            sortField2: "fullName",
            orderBy2: "asc",
            sDialog: false,
            scDialog: false,
            cDialog: false,
            uDialog: false,
            addStudentHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "SĐT",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                },
                {
                    text: "Xử lý",
                    value: "name",
                    align: "center",
                    sortable: false,
                    width: "10%"
                }
            ],
            addStudentConfirmHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Email",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "Số điện thoại",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                },
                {
                    text: "Tài khoản YOCLASS",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                },
                {
                    text: "Hành động",
                    value: "name",
                    align: "center",
                    sortable: false,
                    width: "10%"
                }

            ],
            studentCreateHeaders: [
                {
                    text: "STT",
                    align: "center",
                    sortable: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "Họ và tên",
                    align: "left",
                    sortable: false,
                    value: "name",
                    width: "25%"
                },
                {
                    text: "Tên người dùng (Username)",
                    align: "left",
                    sortable: false,
                    value: "email",
                    width: "25%"
                },
                {
                    text: "Mật khẩu",
                    align: "left",
                    sortable: false,
                    value: "phone",
                    width: "25%"
                }
            ],
            lstInsertStudent: [],
            addSuccess: 0,
            createdSuccess:0,
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
                orderBy: 'fullName',
                descending: false
            },
        }),

        watch: {
            value(val) {
                this.sDialog = val;
                this.init();
            },

            sDialog: function(val){
                //console.log(val);
                if(val == false){
                    this.$emit("close");
                }
            }
        },

        computed:{
        },

        created() {
            //this.init();
            //this.getClass();
        },
        methods: {
            show() {
                this.lstInsertStudent = [];
                this.pushEmptyStudent();
                this.step = 0;
                this.err = {
                    fullName: [],
                    phone: [],
                    email: []
                };
                this.sDialog = true;
            },

            getStudentInfo(item, index) {
                let url = process.env.VUE_APP_API_URL + "/school/student";
                axios
                    .post(url, item)
                    .then(
                        data => {
                            if (data == null || data == "") {

                            } else {
                                item = data;
                                if(item.userId != null && (item.studentId == null || item.studentId == 0)){
                                    message.error("Thông tin tài khoản bạn vừa nhập trùng với tài khoản giáo viên nên không thể đưa vào danh sách");
                                    item['email'] = "";
                                    item["phone"] = "";
                                    item["fullName"] = "";
                                    this.lstInsertStudent.splice(index, 1,item);
                                    document.getElementById("fullName_" + index).focus();
                                } else {
                                    document.getElementById("email_" + index).disabled = true;
                                    document.getElementById("phone_" + index).disabled = true;
                                    document.getElementById("fullName_" + index).disabled = true;
                                    //let newarr = this.lstInsertStudent;
                                    //newarr[index] =  item;
                                    this.lstInsertStudent.splice(index, 1, item);
                                }
                                ////console.log(this.lstInsertStudent);
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            enterInList: function (e) {
                ////console.log(e);
                let row = parseInt(e.target.getAttribute("row"));
                let col = parseInt(e.target.getAttribute("col"));
                ////console.log(row + "-" + col);
                let next = "";
                if (col < 2) {
                    if (col == 0) {
                        next = "email_" + row;
                    } else {
                        next = "phone_" + row;
                    }
                    document.getElementById(next).focus();
                } else {
                    ////console.log(row + "-")
                    if (row == this.lstInsertStudent.length - 1) {
                        this.pushEmptyStudent();
                        this.$nextTick(() => {
                            row += 1;
                            next = "fullName_" + row;
                            ////console.log(next);
                            document.getElementById(next).focus();
                        })
                    } else {
                        row += 1;
                        next = "fullName_" + row;
                        ////console.log(next);
                        document.getElementById(next).focus();
                    }
                }
            },

            getUserName: function (student) {
                if (student.email != null && student.email != "") {
                    return student.email;
                } else {
                    return student.phone;
                }
            },
            getAccountStatus: function (item) {
                if (item.userId == null || item.userId == 0) {
                    return "Chưa có";
                } else {
                    return "Đã có";
                }
            },
            getActionName(item) {
                if (item.userId != undefined && item.userId != null && item.userId != "") {
                    if (item.status == 1) {
                        return "Đã được thêm vào lớp";
                    } else {
                        return "Thêm vào lớp";
                    }
                } else {
                    return "Tạo tài khoản";
                }
            },

            pushEmptyStudent() {
                this.lstInsertStudent.push({
                    "fullName": "",
                    "email": "",
                    "phone": ""
                });
                this.err.fullName.push("");
                this.err.email.push("");
                this.err.phone.push("");
            },

            removeInsertStudent(index) {
                this.lstInsertStudent.splice(index, 1);
                this.err.fullName.splice(index, 1);
                this.err.email.splice(index, 1);
                this.err.phone.splice(index, 1);
            },

            onCheckAccount() {
                if (this.lstInsertStudent.length == 0) {
                    message.error("Bạn chưa nhập thông tin học viên");
                    return;
                }

                this.err = {
                    fullName: Array(this.lstInsertStudent.length).fill(""),
                    email: Array(this.lstInsertStudent.length).fill(""),
                    phone: Array(this.lstInsertStudent.length).fill("")
                }
                let validate = true;
                for (let i = 0; i < this.lstInsertStudent.length; i++) {
                    if (this.lstInsertStudent[i].fullName == null || this.lstInsertStudent[i].fullName.trim().length == 0) {
                        this.err.fullName[i] = "Không được phép để trống";
                        validate = false;
                    }
                    if ((this.lstInsertStudent[i].email == null || this.lstInsertStudent[i].email.trim().length == 0)
                        && (this.lstInsertStudent[i].phone == null || this.lstInsertStudent[i].phone.trim().length == 0)) {
                        this.err.email[i] = "Không được phép để trống cả email và số điện thoại";
                        this.err.phone[i] = "Không được phép để trống cả email và số điện thoại";
                        validate = false;
                    } else {
                        if ((this.lstInsertStudent[i].email != null && this.lstInsertStudent[i].email.trim().length > 0)) {
                            if (!v.validateEmail(this.lstInsertStudent[i].email)) {
                                this.err.email[i] = "Không đúng định dạng email";
                                validate = false;
                            }

                        }

                        if ((this.lstInsertStudent[i].phone != null && this.lstInsertStudent[i].phone.trim().length > 0)) {
                            if (!v.validatePhone(this.lstInsertStudent[i].phone)) {
                                this.err.phone[i] = "Không đúng định dạng số điện thoại";
                                validate = false;
                            }
                        }
                    }

                }
                if (!validate) {
                    return;
                }
                let url = process.env.VUE_APP_API_URL + "/classmember/checkMembers?classId=" + this.classId;
                axios
                    .post(url, this.lstInsertStudent)
                    .then(
                        data => {
                            for (let i = 0; i < data.length; i++) {
                                if (data[i].status == 0 || data[i].status == null) {
                                    data[i].selected = true;
                                } else {
                                    data[i].selected = true;
                                }
                            }
                            this.lstInsertStudent = data;
                            this.step = 1;
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            onAddMember() {
                let url = process.env.VUE_APP_API_URL + "/classmember/addMembers?classId=" + this.classId;
                axios
                    .post(url, this.lstInsertStudent)
                    .then(
                        data => {
                            if (data.success) {
                                this.addSuccess = parseInt(data.ref);
                                if (this.addSuccess == this.lstInsertStudent.length) {
                                    this.step = 4;
                                } else {
                                    for (let i = this.lstInsertStudent.length - 1; i >= 0; i--) {
                                        if (!this.lstInsertStudent[i].selected || this.lstInsertStudent[i].userId != null) {
                                            this.lstInsertStudent.splice(i, 1);
                                        }
                                    }
                                    if (this.lstInsertStudent.length > 0) {
                                        this.step = 2;
                                    } else {
                                        this.step = 4;
                                    }
                                }
                            }
                        },
                        error => {
                            message.error(error);
                        }
                    );
            },

            onCreateAccount() {
                this.err = {
                    fullName: Array(this.lstInsertStudent.length).fill(""),
                    email: Array(this.lstInsertStudent.length).fill(""),
                    phone: Array(this.lstInsertStudent.length).fill(""),
                    password:Array(this.lstInsertStudent.length).fill(""),
                }
                let validate =true;
                for (let i = 0; i < this.lstInsertStudent.length; i++) {
                    if (this.lstInsertStudent[i].password == null || this.lstInsertStudent[i].password.trim().length == 0) {
                        this.err.password[i] = "Không được phép để trống";
                        validate = false;
                    } else if (this.lstInsertStudent[i].password.trim().length <8){
                        this.err.password[i] = "Mật khẩu phải dài ít nhất 8 kí tự";
                        validate = false;
                    }
                }
                if(validate) {
                    let url = process.env.VUE_APP_API_URL + "/school/createStudentOfClass?classId=" + this.classId;
                    axios
                        .post(url, this.lstInsertStudent)
                        .then(
                            data => {
                                if (data.success) {
                                    this.createdSuccess = parseInt(data.ref)
                                    this.step = 3;
                                } else {
                                    message.error(data.description);
                                }
                            },
                            error => {
                                message.error(error);
                            }
                        );
                }
            },
            numberOfExistStudent: function(){
                let count = 0;
                for(let i=0;i<this.lstInsertStudent.length;i++){
                    if(this.lstInsertStudent[i].status == 1 && this.lstInsertStudent[i].selected){
                        count++;
                    }
                }
                return count;
            },

            numberOfSelectedStudent(){
                let count = 0;
                //console.log(this.lstInsertStudent);
                for(let i=0;i<this.lstInsertStudent.length;i++){
                    if(this.lstInsertStudent[i].selected){
                        count++;
                    }
                }
                return count;
            },

            numberOfAddStudent: function(){
                let total = this.numberOfSelectedStudent();
                let exist = this.numberOfExistStudent();
                let remain = total-exist;
                return remain + "/" + total;
            },

            numberOfCreateStudent: function(){
                let count = 0;
                //console.log(this.lstInsertStudent);
                for(let i=0;i<this.lstInsertStudent.length;i++){
                    if(this.lstInsertStudent[i].userId == null && this.lstInsertStudent[i].selected){
                        count++;
                    }
                }
                return count;

            }
        }
    };
</script>